import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { loginRequest } from '@case-management/app/auth.config';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	private msalService = inject(MsalService);
	private router = inject(Router);

	private readonly authService = inject(MsalService);

	getToken(): Promise<string | null> {
		const activeAccount = this.authService.instance.getAllAccounts();
		if (activeAccount) {
			return this.authService.instance
				.acquireTokenSilent({
					account: activeAccount[0],
					scopes: loginRequest.scopes,
				})
				.then((response: AuthenticationResult) => {
					const accessToken = response.accessToken;
					localStorage.setItem('cmToken', accessToken);
					return accessToken;
				})
				.catch((error) => {
					// console.error('Token acquisition', error);
					return null;
				});
		}
		return Promise.resolve(null);
	}

	redirectLogin() {
		localStorage.removeItem('cmToken');
		this.authService.logout();
	}

	refreshToken() {
		const activeAccount = this.authService.instance.getAllAccounts();
		if (activeAccount) {
			return this.msalService.instance
				.acquireTokenSilent({
					scopes: loginRequest.scopes,
					account: activeAccount[0],
				})
				.then((response: AuthenticationResult) => {
					const accessToken = response.accessToken;
					localStorage.setItem('cmToken', accessToken);
					const currentUrl = this.router.url;
					// Navigate to the same route
					if (currentUrl == '/view') {
						this.router.navigate(['/view/case-list']);
					} else {
						this.router
							.navigateByUrl('/', { skipLocationChange: true })
							.then(() => {
								this.router.navigate([currentUrl]);
							});
					}
					// return accessToken;
				})
				.catch((error) => {
					console.error('Silent token acquisition failed:', error);
					// Check if the user needs to be redirected to login
					this.authService.logout();
					if (error.errorMessage.includes('interaction_required')) {
						this.msalService.instance.loginRedirect();
					}
				});
		} else {
			console.warn('No active account found');
			return null;
		}
	}
}
